import { useNavigate } from "react-router";
import { routes } from "pages/routes";
import PageFormWithHeader from "components/page/PageForm/PageFormWithHeader";
import Button from "components/formElements/Button/Button";

import "./PasswordResetDone.css";

// FIXME missing translations
export default function PasswordResetDone() {
  const navigate = useNavigate();
  const navigateToRoot = () => {
    navigate(routes.public.signIn.path());
  };

  const action = (
    <div>
      <Button className="btn" onClick={navigateToRoot}>
        Sign In
      </Button>
    </div>
  );

  return (
    <PageFormWithHeader
      className="reset-done"
      formClassName="resetdone-form"
      title="Your password has been reset"
      formActions={action}
      withLogo
    >
      <div>
        <p>
          Your Talaera password has been reset. To continue, please sign in with your new
          password now.
        </p>
      </div>
    </PageFormWithHeader>
  );
}
